// extracted by mini-css-extract-plugin
export var columnList = "_ab-0";